import {IconButton, styled} from "@mui/material";
import {addOpenDrawer} from "store/actions/appAction";
import CloseIcon from "assets/icons/CloseIcon";
import {useDispatch} from "react-redux";
import MobileSidebarinner from "./MobileSidebarinner";
import appLogo from "assets/images/appLogo.svg";

const HeaderWrapper = styled("div")(({theme}) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    margin: "0 !important",
    height: "64px",
    zIndex: 6,
    padding: "24px",
}));
const Logo = styled("img")(({theme}) => ({
    height: "48px",
    width: "auto",
}));

const MobileSidebar = () => {
    const dispatch = useDispatch();
    return (
        <div>
            <HeaderWrapper>
                <IconButton
                    disableRipple
                    disableFocusRipple
                    onClick={() => dispatch(addOpenDrawer(false, "sidebarDrawer"))}
                    sx={{width: 30, height: 30, padding: 0}}
                >
                    <CloseIcon/>
                </IconButton>
                <Logo src={appLogo}/>
                {/* <div className="col-6 col-lg-1 col-md-1 col-sm-6 col-xs-6 nav-right">
                        <a href="/" onClick={(e) => {
                            dispatch(setBusiness(null))
                            navigate("./")
                            e.preventDefault()
                        }}>
                            <img
                                src={logo}
                                alt="logo"
                                style={{ cursor: "pointer" }}
                            />
                        </a>
                    </div> */}
                <div className="condition">
                    <div className="profile-panle"></div>
                </div>
            </HeaderWrapper>

            <MobileSidebarinner/>
        </div>
    );
};

export default MobileSidebar;
